import { Button, Image } from "react-bootstrap";
import avatarPro from "assets/img/Share-Safari/dpinterested.png";
import { Link } from "react-router-dom";
import InterestesUserModal from "./InterestedUserModal";
import { useSharedSafariContext } from "provider/ShareSafariProvider";
import InterestedUsersSkeleton from "components/common/Skeleton/safari/InterestedUsersSkeleton";

const InterestedUsers = () => {
  const {
    safariViewLoading,
    intreastedUsers,
    totalIntreastedUsers,
    instUserToggle,
    sharedSafariDispatch,
  } = useSharedSafariContext();


  const extraUser = intreastedUsers?.length > 40 ? 40 : intreastedUsers?.length


  return (
    <>
      <Button
        className="intested_btn interestBtn "
        style={{ backgroundColor: "var(--background-primary)" }}
        onClick={() => {
          sharedSafariDispatch({
            type: "SET_SHARED_SAFARI_VIEW_USERS_TOGGLE",
            payload: true,
          });
        }}
      >
        <i className="fa-solid fa-user-group"></i> Interested -{" "}
        {totalIntreastedUsers}
      </Button>

      <div className="interst_wrapper bg-white p-3">
        {safariViewLoading ? <InterestedUsersSkeleton count={3} /> :
          <div className="users_profile d-flex gap-2 align-items-center flex-wrap">
            {intreastedUsers.slice(0, 40).map((user) => (
              <div key={user.id} className="profileavtar">
                <Link
                  to={`/profile/user/${user?.user_handle}`}
                  data-pjax="0"
                >
                  <Image
                    src={user?.profile_display_image || avatarPro}
                    alt="Interested User"
                    className="rounded-circle bg-info"
                    width={40}
                    height={40}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = avatarPro;
                    }}
                  />
                </Link>
              </div>
            ))}
          </div>
        }
        {totalIntreastedUsers > 50 && (
          <p className="text-center mt-2"
            style={{ cursor: "pointer" }}
            onClick={() => {
              sharedSafariDispatch({
                type: "SET_SHARED_SAFARI_VIEW_USERS_TOGGLE",
                payload: true,
              });
            }}
          >
            + {totalIntreastedUsers - extraUser} more interested users
          </p>
        )}
      </div>
      {instUserToggle && <InterestesUserModal />}
    </>
  );
};

export default InterestedUsers;
